// extracted by mini-css-extract-plugin
export var backBtn = "heropage-module--backBtn--ec839";
export var heroDate = "heropage-module--heroDate--4d8ff";
export var heroPage = "heropage-module--heroPage--3a9ef";
export var heroTitle = "heropage-module--heroTitle--0ad4a";
export var sm = "heropage-module--sm--72579";